import React from 'react';

const Contact = () => {
  return (
    <div className='contact-wrap'>
      <ul className='contact-txt'>
        <li>
          <p>E - M A I L</p>
          <p>shalomseonmi@gmail.com</p>
        </li>
        <li>
          <p>T E L</p>
          <p>010 3354 6632</p>
        </li>
      </ul>
      <p className='copyright'>COPYRIGHT SEONMI KIM 2025. ALL RIGHTS RESERVED.</p>
    </div>
  );
};

export default Contact;